import { GetterTree } from "vuex";
import { RootState } from "../types";
import { JobsInterface } from "./types";
export const getters: GetterTree<JobsInterface, RootState> = {};
